<template>
  <div id="app">
    <Wrap></Wrap>
  </div>
</template>

<script>
import Wrap from './new-login-2018/Wrap'
import elHeader from './components/Header'

export default {
  name: 'app',
  components: {
    Wrap: Wrap,
    elHeader: elHeader
  }
}
</script>

<style lang="less">
#app {
  // .main {
  //   font-size: 0.1em;
  // }
}
</style>



// WEBPACK FOOTER //
// App.vue?6c6a114f